import React from "react"
import "./frames.css"

const Caracteristicas = () => {
  return (
    <div className="frames-container">
      <div className="frames-title">
        Características de las Cámaras Hiperbáricas: Eficiencia y Diseño
        Innovador
      </div>

      <div className="frames-subtitle">
        Optimización del Espacio en Centros Sanitarios
      </div>
      <div className="frames-text">
        El diseño de nuestras cámaras hiperbáricas enfrenta de forma innovadora
        el desafío del espacio limitado en centros sanitarios. Permite la
        ubicación del carro de la camilla en la parte baja de la propia cámara,
        optimizando el uso del espacio y mejorando la comodidad y eficiencia de
        la operación. Este diseño es especialmente recomendable en salas
        pequeñas y cuando se usan múltiples cámaras.
      </div>

      <div className="frames-subtitle">Modelos Disponibles</div>
      <div className="frames-text">
        Este diseño innovador se encuentra disponible en los modelos SIGMA 34,
        SIGMA 36 y SIGMA 40.
      </div>

      <div className="frames-subtitle">Sistema de Comunicación</div>
      <div className="frames-text">
        Contamos con un sistema de intercomunicación bidireccional especialmente
        diseñado para entornos hiperbáricos y con oxígeno. Viene equipado con
        baterías de seguridad para mantener la comunicación incluso cuando no
        hay suministro eléctrico.
      </div>

      <div className="frames-subtitle">Calidad de Materiales</div>
      <div className="frames-text">
        Nuestras cámaras ofrecen un cilindro de metacrilato de alta calidad con
        visión 360º, sostenido en su lugar por tirantes de acero de alta
        resistencia.
      </div>

      <div className="frames-subtitle">Comodidad y Seguridad</div>
      <div className="frames-text">
        Utilizamos camillas de la marca Stryker, especialmente adaptadas para
        nuestras cámaras, ofreciendo un nivel adicional de comodidad y seguridad
        para el paciente. También proporcionamos un sistema de entretenimiento y
        soporte para un monitor de 32 pulgadas, especialmente recomendado para
        el modelo SIGMA 40.
      </div>

      <div className="frames-subtitle">Funcionalidades Adicionales</div>
      <div className="frames-text">
        Las cámaras están equipadas con conexiones que permiten la
        monitorización y administración de medicamentos durante el tratamiento.
        Estas conexiones son compatibles con el Sistema de Air Break, demandado
        por su efecto de hipoxia/hiperoxia.
      </div>
    </div>
  )
}

export default Caracteristicas
